import { GridCellProps } from '@progress/kendo-react-grid';
import { ActionsEllipsisCell } from 'Components/Grid';
import { useGridState, useToasts } from 'Context';
import {
  ActionsDropdownConfig,
} from 'Models';
import { Permission } from 'Models/Templates/Permission/Permission';
import { ENDPOINTS } from 'Models/Templates/Routes/Routes';
import React from 'react';
import { buildEndpoint, useApiWorker } from 'Utilities';
import { AppointmentLetterModal, AppointmentLetterModel } from 'Models/AppointmentLetterModel';
import { AppointmentLetterDrawerForm } from './AppointmentLetterDrawerForm';

export const AppointmentLetterActionCell: React.FC<GridCellProps> = ({
  dataItem,
  field = '',
}) => {
  const API = useApiWorker();
  const toast = useToasts();
  const { refreshGrid } = useGridState();
  const value = dataItem[field];

  const deleteItem = async () => {
    if (window.confirm('Are you sure you want to delete this letter?')) {
      try {
        var deleteResponse = await API.delete(
          buildEndpoint(ENDPOINTS.appointmentletters.base, value)
        );
        if (deleteResponse.data.isSuccessStatusCode) {
          toast.success('Letter has been removed.');
        } else if (deleteResponse.headers['exception'] === undefined) {
          toast.error('Failed removing letter.');
        } else {
          toast.error(deleteResponse.headers['exception']);
        }
        refreshGrid && refreshGrid();
      } catch {
        toast.error('Failed removing letter.');
      }
    }
  };

  const actionsConfig: ActionsDropdownConfig = {
    items: [
      {
        name: 'Edit',
        permissions: [Permission.EditAppointmentDocument],
        modalConfig: {
          modalId: AppointmentLetterModal.Attachments,
          entityId: value,
          modalComponent: (
            <AppointmentLetterDrawerForm
              formModel={new AppointmentLetterModel(value)}
              endpoint={ENDPOINTS.appointmentletters.base}
            />
          ),
        },
      },
      {
        name: 'Delete',
        onClick: deleteItem,
        permissions: [Permission.DeleteAppointmentDocument],
      },
    ],
  };

  return (
    <ActionsEllipsisCell actionsConfig={actionsConfig} dataItem={dataItem} />
  );
};
